import { ChiTietSoLuongTonComponent } from './chuc-nang-kho/kho-de-nghi-xuat-kho/chi-tiet-so-luong-ton/chi-tiet-so-luong-ton.component';
import { KhoDeNghiXuatKhoModule } from './chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho.module';
import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PartialsModule } from '../../partials/partials.module';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS_EDIT } from './datepicker';
import { PopoverModule } from 'ngx-smart-popover';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbProgressbarModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatListModule,
	MatChipsModule,
	MatStepperModule,

} from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from '../../../app.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DropdownTreeModule, ImageControlModule, DatetimePickerModule } from 'dps-lib';
import { QRCodeModule } from 'angular2-qrcode';
//Extends Component
import { DisableDoubleClickDirective } from './disable-double-click.directive';
import { ThongTinHangVeListV2Component } from './chuc-nang-kho/kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-list/phieu-thong-tin-hang-ve-ver2-list.component';
import { NhapKhoVer2ListComponent } from './chuc-nang-kho/kho-nhap-kho/phieu-nhap-kho-ver2-list/phieu-nhap-kho-ver2-list.component';
import { DeNghiMuaHangListComponent } from './mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-list/de-nghi-mua-hang-list.component';
import { TonKhoHienTaiListComponent } from './chuc-nang-kho/ton-kho-hien-tai/ton-kho-hien-tai-list/ton-kho-hien-tai-list.component';
import { KhoDeNghiXuatKhoListComponent } from './chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho-list/kho-de-nghi-xuat-kho-list.component';
import { SoDoKhoViewComponent } from './chuc-nang-kho/so-do-kho/so-do-kho-view-dialog/so-do-kho-view-dialog.component';
import { SoDoKhoViewVer2Component } from './chuc-nang-kho/so-do-kho/so-do-kho-view-dialog-ver2/so-do-kho-view-dialog-ver2.component';
import { XemHangLuuKhoComponent } from './chuc-nang-kho/so-do-kho/xem-hang-luu-kho/xem-hang-luu-kho.component';
import { QrPalletComponent } from './chuc-nang-kho/so-do-kho/qr-pallet/qr-pallet.component';
import { YeuCauDuyetGiaListComponent } from './kinh-doanh/yeu-cau-duyet-gia/yeu-cau-duyet-gia-list/yeu-cau-duyet-gia-list.component';
import { YeuCauDuyetGiaEditComponent } from './kinh-doanh/yeu-cau-duyet-gia/yeu-cau-duyet-gia-edit/yeu-cau-duyet-gia-edit.component';
import { ChonNhieuHangHoaListDialogComponent } from './components/list-dialog/chon-nhieu-hang-hoa/chon-nhieu-hang-hoa-list-dialog.component';
import { ChonNhieuHangHoaTongHopListDialogComponent } from './components/list-dialog/chon-nhieu-hang-hoa-tong-hop/chon-nhieu-hang-hoa-tong-hop-list-dialog.component';
// import { HC_BaoComComponent } from './hanh-chanh/hc-thuc-don-tuan/hc-thuc-don-tuan.component';
import { ThanhPhamEditComponent } from './thanh-pham/thanh-pham-edit/thanh-pham-edit.component';
import { BanThanhPhamEditComponent } from './ban-thanh-pham/ban-thanh-pham-edit/ban-thanh-pham-edit.component';
import { NguyenLieuEditComponent } from './nguyen-lieu/nguyen-lieu-edit/nguyen-lieu-edit.component';
import { PhuLieuEditComponent } from './phu-lieu/phu-lieu-edit/phu-lieu-edit.component';
import { ThemMoiKHComponent } from './kinh-doanh/kd-yeu-cau-bao-gia/them-moi-kh/them-moi-kh.component';
import { NhaCungCapEditComponent } from './nha-cung-cap/nha-cung-cap-edit/nha-cung-cap-edit.component';
//Extends Services
import { NhapKhoVer2Service } from './chuc-nang-kho/kho-nhap-kho/phieu-nhap-kho-ver2-service/phieu-nhap-kho-ver2.service';
//import { ThongTinHangVeService } from './chuc-nang-kho/kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { ThongTinHangVeService } from './chuc-nang-kho-page/kho-phieu-thong-tin-hang-ve-page/phieu-thong-tin-hang-ve-service-page/phieu-thong-tin-hang-ve.service';
import { KeHoachHangVeTTHVService } from './chuc-nang-kho/kho-phieu-thong-tin-hang-ve/ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
import { DeNghiMuaHangService } from './mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { TonKhoHienTaiService } from './chuc-nang-kho/ton-kho-hien-tai/ton-kho-hien-tai-service/ton-kho-hien-tai.service';
import { KhoDeNghiXuatKhoService } from './chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';
import { DungChungService } from './dung-chung/__services/dung-chung.service';
import { KhachHangService } from './danh-muc/khach-hang/khach-hang-service/khach-hang.service';
import { SoDoKhoService } from './chuc-nang-kho/so-do-kho/so-do-kho-service/so-do-kho.service';
import { YeuCauDuyetGiaService } from './kinh-doanh/yeu-cau-duyet-gia/yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
import { ListDialogService } from './components/list-dialog/Services/list-dialog.service';
import { HC_BaoComService } from './hanh-chanh/hc-bao-com/hc-bao-com-service/hc-bao-com.service';
import { ThanhPhamService } from './thanh-pham/thanh-pham-service/thanh-pham.service';
import { DynamicSearchFormModule } from '../components/dynamic-search-form/dynamic-search-form.module';
import { DynamicSearchFormService } from '../components/dynamic-search-form/dynamic-search-form.service';
import { TongHopMuaHangStackChartComponent } from './charts/tong-hop-mua-hang-stack-chart/tong-hop-mua-hang-stack-chart.component';
import { ChartsService } from './charts/charts-service/charts.service';
import { TongHopMuaHangChartsComponent } from './charts/tong-hop-mua-hang-charts/tong-hop-mua-hang-charts.component';
import { ThongKeTonKhoHienTaiChartComponent } from './charts/thong-ke-ton-kho-hien-tai-chart/thong-ke-ton-kho-hien-tai-chart.component';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { ChiTietSoLuongTonPageComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/chi-tiet-so-luong-ton-page/chi-tiet-so-luong-ton-page.component';
import { KhoDeNghiXuatKhoPageService } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-page-service/kho-de-nghi-xuat-kho-page.service';
import { ChonDeNghiTamUngModule } from './components/list-dialog/chon-de-nghi-tam-ung/chon-de-nghi-tam-ung.module'
import { TheoDoiKhoiLuongNhapKhoChartComponent } from './charts/theo-doi-khoi-luong-nhap-kho-chart/theo-doi-khoi-luong-nhap-kho-chart.component';
import { TheoDoiKhoiLuongXuatKhoChartComponent } from './charts/theo-doi-khoi-luong-xuat-kho-chart/theo-doi-khoi-luong-xuat-kho-chart.component';
import { KhoDangKiemKeComponent } from './charts/kho-dang-kiem-ke/kho-dang-kiem-ke.component';
import { KetQuaSanXuatComponent } from './charts/ket-qua-san-xuat/ket-qua-san-xuat.component';
import { DeNghiMuaHangPageAddEditDialogComponent } from './mua-hang-page/de-nghi-mua-hang/de-nghi-mua-hang-page-200803/de-nghi-mua-hang-page-add-edit-dialog/de-nghi-mua-hang-page-add-edit-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AddDoiTuongComponent } from './components/list-dialog/add-doi-tuong/add-doi-tuong.component';
import { DeNghiNhapKhoDetailDialogComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-detail-dialog/kho-de-nghi-nhap-kho-detail-dialog.component';
import { ThongTinHangVeDetailDialogComponent } from './chuc-nang-kho-page/kho-phieu-thong-tin-hang-ve-page/phieu-thong-tin-hang-ve-detail-dialog/phieu-thong-tin-hang-ve-detail-dialog.component';
import { GetDonViComponent } from './components/list-dialog/get-don-vi/get-don-vi.component';
import { YeuCauBaoGiaDetailComponent } from './kinh-doanh/kd-yeu-cau-bao-gia-dialog/kd-yeu-cau-bao-gia-dialog-detail/kd-yeu-cau-bao-gia-dialog-detail.component';
import { DNNKLSNhapKhoDialogComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-lich-su-nhap-list-dialog/kho-lich-su-nhap-list-dialog.component';
import { NhapKhoPageDialogComponent } from './chuc-nang-kho-page/kho-nhap-kho-page/kho-nhap-kho-page-dialog/kho-nhap-kho-page-dialog.component';
import { KhoXuatKhoPageDialogComponent } from './chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-kho-page-dialog/kho-xuat-kho-page-dialog.component';
import { KhoDeNghiXuatKhoDialogDetailComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-dialog-detail/kho-de-nghi-xuat-kho-dialog-detail.component';
import { KhoNhapPageFileComponent } from './chuc-nang-kho-page/kho-nhap-kho-page/kho-nhap-page-file/kho-nhap-page-file.component';
import { KhoXuatPageFileComponent } from './chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-page-file/kho-xuat-page-file.component';
import { DeNghiNhapKhoAddEditDialogComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-add-edit-dialog/kho-de-nghi-nhap-kho-add-edit-dialog.component';
import { KhieuNaiKhachHangDetailComponent } from './kinh-doanh/khieu-nai-khach-hang/khieu-nai-khach-hang-detail/khieu-nai-khach-hang-detail.component';
import { XacNhanHuyComponent } from './san-xuat/ke-hoach-san-xuat/xac-nhan-huy-dialog/xac-nhan-huy-dialog.component';
import { ChonDoiTuongTHCPModule } from './components/list-dialog/chon-doi-tuong-thcp/chon-doi-tuong-thcp.module';
import { BaoCaoChiTietDonHangBanDetailComponent } from './thong-ke-bao-cao/bao-cao-chi-tiet-don-hang-ban/bao-cao-chi-tiet-don-hang-ban-detail/bao-cao-chi-tiet-don-hang-ban-detail.component';
import { BaoCaoChiTietDonHangBanService } from './thong-ke-bao-cao/bao-cao-chi-tiet-don-hang-ban/bao-cao-chi-tiet-don-hang-ban-service/bao-cao-chi-tiet-don-hang-ban.service';
import { CdkTableModule } from '@angular/cdk/table';
import { PhieuKiemTraDetailDialogComponent } from './qa-qc/kiem-tra-hang-hoa/phieu-kiem-tra/phieu-kiem-tra-chi-tiet-dialog/phieu-kiem-tra-chi-tiet-dialog.component';
import { PhieuKiemTraService } from './qa-qc/kiem-tra-hang-hoa/phieu-kiem-tra/phieu-kiem-tra-service/phieu-kiem-tra.service';
import { NgxPrintModule } from 'ngx-print';
import { ThongTinHangVeDetailDialogCloneComponent } from './chuc-nang-kho-page/kho-phieu-thong-tin-hang-ve-page-clone/phieu-thong-tin-hang-ve-detail-dialog/phieu-thong-tin-hang-ve-detail-dialog.component';
import { ChiTietKQSXPhongCanComponent } from './san-xuat/ghi-nhan-kqsx-phong-can/chi-tiet-kqsx-phong-can/chi-tiet-kqsx-phong-can.component';
import { DeNghiNhapKhoService } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
import { ContentComponent } from '../components/content-component/content-component.component';
import { YeuCauXuatKhanEditDialogComponent } from './ke-hoach/yeu-cau-xuat-khan/yeu-cau-xuat-khan-edit-dialog/yeu-cau-xuat-khan-edit-dialog.component';
import { YeuCauXuatKhanService } from './ke-hoach/yeu-cau-xuat-khan/yeu-cau-xuat-khan-service/yeu-cau-xuat-khan.service';
import { ListDocumentInSystemComponent } from './qa-qc/quan-ly-tai-lieu/yeu-cau-mua/danh-sach-tai-lieu/danh-sach-tai-lieu.component';
import { FShareService } from './qa-qc/quan-ly-tai-lieu/danh-muc/fshare/fshare.service';
import { BOMDetailDialogComponent } from './rd/bom/bom-detail-dialog/bom-detail-dialog.component';
import { BOMStepOneComponent } from './rd/bom/bom-step-one/bom-step-one.component';
import { BOMStepThreeComponent } from './rd/bom/bom-step-three/bom-step-three.component';
import { BOMStepTwoComponent } from './rd/bom/bom-step-two/bom-step-two.component';
import { BOMStepFourComponent } from './rd/bom/bom-step-four/bom-step-four.component';
import { CongThucDinhMucService } from './rd/cong-thuc-dinh-muc/cong-thuc-dinh-muc-service/cong-thuc-dinh-muc.service';
import { DonHangMuaDialogDetailComponent } from './mua-hang-page/don-hang-mua/don-hang-mua-dialog-detail/don-hang-mua-dialog-detail.component';
import { DonHangMuaService } from './mua-hang-page/don-hang-mua/don-hang-mua-page-service/don-hang-mua.service';
import { ThietLapDonHangMuaService } from './mua-hang-page/thiet-lap-don-hang-mua/thiet-lap-don-hang-mua-service/thiet-lap-don-hang-mua.service';
import { NguyenLieuService } from './nguyen-lieu/nguyen-lieu-service/nguyen-lieu.service';
import { KDDatHangService } from './kinh-doanh/kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service';
import { LichSuGiaMuaHangComponent } from './mua-hang-page/don-hang-mua/lich-su-gia-mua-hang/lich-su-gia-mua-hang.component';
import { ChartMuaHangModule } from '../components/chart-mua-hang/chart-mua-hang.module';
import { LichSuGiaoHangComponent } from './mua-hang-page/don-hang-mua/lich-su-giao-hang/lich-su-giao-hang.component';
import { DuyetDonHangMuaComponent } from './mua-hang-page/don-hang-mua/duyet-don-hang-mua/duyet-don-hang-mua.component';
import { KeHoachNCCGiaoHangComponent } from './mua-hang-page/don-hang-mua/ke-hoach-ncc-giao-hang/ke-hoach-ncc-giao-hang.component';
import { RemindDeliveryPlanComponent } from 'app/views/partials/content/crud/remind-delivery-plan/remind-delivery-plan.component';
import { BOMImportResultComponent } from './rd/bom/bom-import-result/bom-import-result.component';
import { QuyTrinhSanXuatPageService } from './rd/quy-trinh-san-xuat-page/quy-trinh-san-xuat-page-service/quy-trinh-san-xuat-page.service';
import { DeNghiChuyenKhoDialogDetailComponent } from './chuc-nang-kho/de-nghi-chuyen-kho/de-nghi-chuyen-kho-dialog-detail/de-nghi-chuyen-kho-dialog-detail.component';
import { KhoDeNghiXuatKhoImportWarningtComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-import-warning/kho-de-nghi-xuat-kho-import-warning.component';
import { DeNghiNhapKhoAddEditComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-add-edit-page/kho-de-nghi-nhap-kho-add-edit-page.component';
import { DeNghiMuaHangPageDetailComponent } from './mua-hang-page/de-nghi-mua-hang/de-nghi-mua-hang-page-200803/de-nghi-mua-hang-page-detail/de-nghi-mua-hang-page-detail.component';
import { LichSuMuaHangDialogComponent } from './mua-hang-page/de-nghi-mua-hang/de-nghi-mua-hang-page-200803/lich-su-mua-hang-list-dialog/lich-su-mua-hang-list-dialog.component';
import { LichSuNhanHangDialogComponent } from './mua-hang-page/de-nghi-mua-hang/de-nghi-mua-hang-page-200803/lich-su-nhan-hang-list-dialog/lich-su-nhan-hang-list-dialog.component';
import { KhoDeNghiXuatKhoPageEditComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-page-edit/kho-de-nghi-xuat-kho-page-edit.component';
import { KhoDeNghiXuatKhoPageDetailComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-page-detail/kho-de-nghi-xuat-kho-page-detail.component';
import { KhoXuatKhoPageDetailComponent } from './chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-kho-page-detail/kho-xuat-kho-page-detail.component';
import { KhoXuatKhoPageService } from './chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-kho-page-service/kho-xuat-kho-page.service';
import { JsPDFFontService } from './dung-chung/__services/pdf-custom-font.service';
import { NhapKhoPageDetailComponent } from './chuc-nang-kho-page/kho-nhap-kho-page/kho-phieu-nhap-kho-detail/kho-phieu-nhap-kho-detail.component';
import { NhapKhoPageService } from './chuc-nang-kho-page/kho-nhap-kho-page/kho-nhap-kho-page-service/kho-nhap-kho-page.service';
import { DeNghiNhapKhoDetailComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-detail-page/kho-de-nghi-nhap-kho-detail-page.component';
import { DuyetDeNghiNhapKhoComponent } from './chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/duyet-de-nghi-nhap-kho-page/duyet-de-nghi-nhap-kho-page.component';
import { DashboardExpiryCardComponent } from './dashboard/dashboard-expiry/dashboard-expiry-card/dashboard-expiry-card.component';
import { DashboardInventoryNormsCardComponent } from './dashboard/dashboard-inventory-norms/dashboard-inventory-norms-card/dashboard-inventory-norms-card.component';
import { DashboardExpiryService } from './dashboard/dashboard-expiry/dashboard-expiry-service/dashboard-expiry.service';
import { DashboardInventoryNormsService } from './dashboard/dashboard-inventory-norms/dashboard-inventory-norms-service/dashboard-inventory-norms.service';
import { PrintTemplateModule } from '../print-template/print-template.module';
import { PrintTemplateComponent } from '../print-template/print-template.component';
import { LichSuXuatKhoComponent } from './chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/lich-su-xuat-kho/lich-su-xuat-kho.component';
import { DeNghiChuyenKhoEditPageComponent } from './chuc-nang-kho/de-nghi-chuyen-kho/de-nghi-chuyen-kho-edit-page/de-nghi-chuyen-kho-edit-page.component';
import { PhieuKiemKeDetailComponent } from './chuc-nang-kho/phieu-kiem-ke/phieu-kiem-ke-detail/phieu-kiem-ke-detail.component';
import { KhoCKNBPageDetailComponent } from './chuc-nang-kho-page/kho-chuyen-kho-noi-bo/kho-chuyen-kho-noi-bo-detail-page/kho-chuyen-kho-noi-bo-detail-page.component';
import { KhoCKNBPageService } from './chuc-nang-kho-page/kho-chuyen-kho-noi-bo/kho-chuyen-kho-noi-bo-page-service/kho-chuyen-kho-noi-bo-page.service';
import { KhoChuyenKhoPageService } from './chuc-nang-kho-page/kho-chuyen-kho/kho-chuyen-kho-page-service/kho-chuyen-kho-page.service';
import { KhoChuyenKhoPageDetailComponent } from './chuc-nang-kho-page/kho-chuyen-kho/kho-chuyen-kho-detail-page/kho-chuyen-kho-detail-page.component';
import { DeNghiChuyenKhoService } from './chuc-nang-kho/de-nghi-chuyen-kho/de-nghi-chuyen-kho-service/de-nghi-chuyen-kho.service';
import { LichSuThaoTacKhoDialogComponent } from '../components/lich-su-thao-tac-kho-dialog/lich-su-thao-tac-kho-dialog.component';
import { BOMDeparmentDropdownComponent } from './rd/bom-department-dropdown/bom-department-dropdown.component';
import { NhapQuyTrinhDuyetService } from './quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service';
import { LoaiPhieuService } from './danh-muc/loai-phieu/loai-phieu-service/loai-phieu.service';
import { LichSuThayDoiForecastComponent } from './kinh-doanh/kd-dat-hang/lich-su-thay-doi-forecast/lich-su-thay-doi-forecast.component';
import { DoiTraHangDetailComponent } from './kinh-doanh/kd-doi-tra-hang/kd-doi-tra-hang-detail/kd-doi-tra-hang-detail.component';
import { ThuMuaHistoryLogComponent } from './mua-hang-page/don-hang-mua/history-log/history-log.component';
import { DashboardExpiryConfigComponent } from './dashboard/dashboard-expiry/dashboard-expiry-config/dashboard-expiry-config.component';
import { SysConfigService } from './cau-hinh/sys-config/sys-config-service/sys-config.service';
import { DashboardInventoryNormConfigComponent } from './dashboard/dashboard-inventory-norms/dashboard-inventory-norm-config/dashboard-inventory-norm-config.component';
import { DonHangMuaEditComponent } from './mua-hang-page/don-hang-mua/don-hang-mua-page-edit/don-hang-mua-edit.component';
@NgModule({
	imports: [
		MatDialogModule,
		CommonModule,
		HttpClientModule,
		PartialsModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatListModule,
		FullCalendarModule,
		PopoverModule,
		NgbProgressbarModule,
		NgbModule,
		NgxPermissionsModule.forChild(),
		NgxMatSelectSearchModule,
		MatChipsModule,
		DropdownTreeModule,
		ImageControlModule,
		DynamicSearchFormModule,
		ChonDeNghiTamUngModule,
		ScrollingModule,
		DatetimePickerModule,
		ChonDoiTuongTHCPModule,
		CdkTableModule,
		NgxPrintModule,
		MatStepperModule,
		ChartMuaHangModule,
		QRCodeModule,
		PrintTemplateModule
	],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'vi' },
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_EDIT },
		ThongTinHangVeService,
		KeHoachHangVeTTHVService,
		NhapKhoVer2Service,
		DeNghiMuaHangService,
		TonKhoHienTaiService,
		KhoDeNghiXuatKhoService,
		DungChungService,
		KhachHangService,
		SoDoKhoService,
		YeuCauDuyetGiaService,
		ListDialogService,
		HC_BaoComService,
		ThanhPhamService,
		DynamicSearchFormService,
		ChartsService,
		LayoutUtilsService,
		KhoDeNghiXuatKhoPageService,
		BaoCaoChiTietDonHangBanService,
		PhieuKiemTraService,
		DeNghiNhapKhoService,
		YeuCauXuatKhanService,
		FShareService,
		CongThucDinhMucService,
		DonHangMuaService,
		ThietLapDonHangMuaService,
		NguyenLieuService,
		KDDatHangService,
		QuyTrinhSanXuatPageService,
		KhoXuatKhoPageService,
		JsPDFFontService,
		NhapKhoPageService,
		DashboardExpiryService,
		DashboardInventoryNormsService,
		SysConfigService,
		KhoCKNBPageService,
		KhoChuyenKhoPageService,
		DeNghiChuyenKhoService,
		NhapQuyTrinhDuyetService,
		LoaiPhieuService
	],
	declarations: [
		DisableDoubleClickDirective,
		ThongTinHangVeListV2Component,
		NhapKhoVer2ListComponent,
		DeNghiMuaHangListComponent,
		TonKhoHienTaiListComponent,
		KhoDeNghiXuatKhoListComponent,
		SoDoKhoViewComponent,
		SoDoKhoViewVer2Component,
		XemHangLuuKhoComponent,
		QrPalletComponent,
		YeuCauDuyetGiaListComponent,
		YeuCauDuyetGiaEditComponent,
		ChonNhieuHangHoaListDialogComponent,
		ChonNhieuHangHoaTongHopListDialogComponent,
		ChiTietSoLuongTonComponent,
		ThemMoiKHComponent,
		NhaCungCapEditComponent,
		ThanhPhamEditComponent,
		BanThanhPhamEditComponent,
		NguyenLieuEditComponent,
		PhuLieuEditComponent,
		TongHopMuaHangStackChartComponent,
		TongHopMuaHangChartsComponent,
		ThongKeTonKhoHienTaiChartComponent,
		ChiTietSoLuongTonPageComponent,
		TheoDoiKhoiLuongNhapKhoChartComponent,
		TheoDoiKhoiLuongXuatKhoChartComponent,
		KhoDangKiemKeComponent,
		KetQuaSanXuatComponent,
		DeNghiMuaHangPageAddEditDialogComponent,
		DeNghiMuaHangPageDetailComponent,
		AddDoiTuongComponent,
		DeNghiNhapKhoDetailDialogComponent,
		ThongTinHangVeDetailDialogComponent,
		GetDonViComponent,
		YeuCauBaoGiaDetailComponent,
		DNNKLSNhapKhoDialogComponent,
		NhapKhoPageDialogComponent,
		KhoXuatKhoPageDialogComponent,
		KhoDeNghiXuatKhoDialogDetailComponent,
		DeNghiChuyenKhoDialogDetailComponent,
		KhoNhapPageFileComponent,
		KhoXuatPageFileComponent,
		DeNghiNhapKhoAddEditDialogComponent,
		KhieuNaiKhachHangDetailComponent,
		XacNhanHuyComponent,
		BaoCaoChiTietDonHangBanDetailComponent,
		PhieuKiemTraDetailDialogComponent,
		ThongTinHangVeDetailDialogCloneComponent,
		ChiTietKQSXPhongCanComponent,
		ContentComponent,
		YeuCauXuatKhanEditDialogComponent,
		ListDocumentInSystemComponent,
		BOMDetailDialogComponent,
		BOMStepOneComponent,
		BOMStepThreeComponent,
		BOMStepTwoComponent,
		BOMStepFourComponent,
		DonHangMuaDialogDetailComponent,
		LichSuGiaMuaHangComponent,
		DuyetDonHangMuaComponent,
		LichSuGiaoHangComponent,
		KeHoachNCCGiaoHangComponent,
		RemindDeliveryPlanComponent,
		BOMImportResultComponent,
		KhoDeNghiXuatKhoImportWarningtComponent,
		DeNghiNhapKhoAddEditComponent,
		LichSuMuaHangDialogComponent,
		LichSuNhanHangDialogComponent,
		KhoDeNghiXuatKhoPageEditComponent,
		KhoDeNghiXuatKhoPageDetailComponent,
		KhoXuatKhoPageDetailComponent,
		NhapKhoPageDetailComponent,
		DeNghiNhapKhoDetailComponent,
		DuyetDeNghiNhapKhoComponent,
		DashboardExpiryCardComponent,
		DashboardExpiryConfigComponent,
		DashboardInventoryNormConfigComponent,
		DashboardInventoryNormsCardComponent,
		PrintTemplateComponent,
		LichSuXuatKhoComponent,
		DeNghiChuyenKhoEditPageComponent,
		PhieuKiemKeDetailComponent,
		KhoCKNBPageDetailComponent,
		KhoChuyenKhoPageDetailComponent,
		LichSuThaoTacKhoDialogComponent,
		BOMDeparmentDropdownComponent,
		LichSuThayDoiForecastComponent,
		DoiTraHangDetailComponent,
    ThuMuaHistoryLogComponent,
    DonHangMuaEditComponent
	],
	entryComponents: [
		ThongTinHangVeListV2Component,
		NhapKhoVer2ListComponent,
		DeNghiMuaHangListComponent,
		TonKhoHienTaiListComponent,
		KhoDeNghiXuatKhoListComponent,
		SoDoKhoViewComponent,
		SoDoKhoViewVer2Component,
		XemHangLuuKhoComponent,
		QrPalletComponent,
		YeuCauDuyetGiaListComponent,
		YeuCauDuyetGiaEditComponent,
		ChonNhieuHangHoaListDialogComponent,
		ChonNhieuHangHoaTongHopListDialogComponent,
		ChiTietSoLuongTonComponent,
		ThemMoiKHComponent,
		NhaCungCapEditComponent,
		ThanhPhamEditComponent,
		BanThanhPhamEditComponent,
		NguyenLieuEditComponent,
		PhuLieuEditComponent,
		TongHopMuaHangStackChartComponent,
		TongHopMuaHangChartsComponent,
		ThongKeTonKhoHienTaiChartComponent,
		ChiTietSoLuongTonPageComponent,
		TheoDoiKhoiLuongNhapKhoChartComponent,
		TheoDoiKhoiLuongXuatKhoChartComponent,
		KhoDangKiemKeComponent,
		KetQuaSanXuatComponent,
		DeNghiMuaHangPageAddEditDialogComponent,
		DeNghiMuaHangPageDetailComponent,
		AddDoiTuongComponent,
		DeNghiNhapKhoDetailDialogComponent,
		ThongTinHangVeDetailDialogComponent,
		GetDonViComponent,
		YeuCauBaoGiaDetailComponent,
		DNNKLSNhapKhoDialogComponent,
		NhapKhoPageDialogComponent,
		KhoXuatKhoPageDialogComponent,
		KhoDeNghiXuatKhoDialogDetailComponent,
		DeNghiChuyenKhoDialogDetailComponent,
		KhoNhapPageFileComponent,
		KhoXuatPageFileComponent,
		DeNghiNhapKhoAddEditDialogComponent,
		KhieuNaiKhachHangDetailComponent,
		XacNhanHuyComponent,
		BaoCaoChiTietDonHangBanDetailComponent,
		PhieuKiemTraDetailDialogComponent,
		ThongTinHangVeDetailDialogCloneComponent,
		ChiTietKQSXPhongCanComponent,
		ContentComponent,
		YeuCauXuatKhanEditDialogComponent,
		ListDocumentInSystemComponent,
		BOMDetailDialogComponent,
		BOMStepOneComponent,
		BOMStepThreeComponent,
		BOMStepTwoComponent,
		BOMStepFourComponent,
		DonHangMuaDialogDetailComponent,
		LichSuGiaMuaHangComponent,
		DuyetDonHangMuaComponent,
		LichSuGiaoHangComponent,
		KeHoachNCCGiaoHangComponent,
		RemindDeliveryPlanComponent,
		BOMImportResultComponent,
		KhoDeNghiXuatKhoImportWarningtComponent,
		DeNghiNhapKhoAddEditComponent,
		LichSuMuaHangDialogComponent,
		LichSuNhanHangDialogComponent,
		KhoDeNghiXuatKhoPageEditComponent,
		KhoDeNghiXuatKhoPageDetailComponent,
		KhoXuatKhoPageDetailComponent,
		NhapKhoPageDetailComponent,
		DeNghiNhapKhoDetailComponent,
		DuyetDeNghiNhapKhoComponent,
		DashboardExpiryCardComponent,
		DashboardExpiryConfigComponent,
		DashboardInventoryNormConfigComponent,
		DashboardInventoryNormsCardComponent,
		PrintTemplateComponent,
		LichSuXuatKhoComponent,
		DeNghiChuyenKhoEditPageComponent,
		PhieuKiemKeDetailComponent,
		KhoCKNBPageDetailComponent,
		KhoChuyenKhoPageDetailComponent,
		LichSuThaoTacKhoDialogComponent,
		BOMDeparmentDropdownComponent,
		LichSuThayDoiForecastComponent,
		DoiTraHangDetailComponent,
    ThuMuaHistoryLogComponent,
    DonHangMuaEditComponent
	],
	exports: [
		DisableDoubleClickDirective,
		ThongTinHangVeListV2Component,
		NhapKhoVer2ListComponent,
		DeNghiMuaHangListComponent,
		TonKhoHienTaiListComponent,
		TonKhoHienTaiListComponent,
		KhoDeNghiXuatKhoListComponent,
		SoDoKhoViewComponent,
		SoDoKhoViewVer2Component,
		XemHangLuuKhoComponent,
		QrPalletComponent,
		YeuCauDuyetGiaListComponent,
		YeuCauDuyetGiaEditComponent,
		ChonNhieuHangHoaListDialogComponent,
		ChonNhieuHangHoaTongHopListDialogComponent,
		ChiTietSoLuongTonComponent,
		ThemMoiKHComponent,
		NhaCungCapEditComponent,
		ThanhPhamEditComponent,
		BanThanhPhamEditComponent,
		NguyenLieuEditComponent,
		PhuLieuEditComponent,
		TongHopMuaHangStackChartComponent,
		TongHopMuaHangChartsComponent,
		ThongKeTonKhoHienTaiChartComponent,
		ChiTietSoLuongTonPageComponent,
		TheoDoiKhoiLuongNhapKhoChartComponent,
		TheoDoiKhoiLuongXuatKhoChartComponent,
		KhoDangKiemKeComponent,
		KetQuaSanXuatComponent,
		DeNghiMuaHangPageAddEditDialogComponent,
		DeNghiMuaHangPageDetailComponent,
		AddDoiTuongComponent,
		DeNghiNhapKhoDetailDialogComponent,
		ThongTinHangVeDetailDialogComponent,
		GetDonViComponent,
		YeuCauBaoGiaDetailComponent,
		DNNKLSNhapKhoDialogComponent,
		NhapKhoPageDialogComponent,
		KhoXuatKhoPageDialogComponent,
		KhoDeNghiXuatKhoDialogDetailComponent,
		DeNghiChuyenKhoDialogDetailComponent,
		KhoNhapPageFileComponent,
		KhoXuatPageFileComponent,
		DeNghiNhapKhoAddEditDialogComponent,
		KhieuNaiKhachHangDetailComponent,
		XacNhanHuyComponent,
		BaoCaoChiTietDonHangBanDetailComponent,
		PhieuKiemTraDetailDialogComponent,
		ThongTinHangVeDetailDialogCloneComponent,
		ChiTietKQSXPhongCanComponent,
		ContentComponent,
		YeuCauXuatKhanEditDialogComponent,
		ListDocumentInSystemComponent,
		BOMDetailDialogComponent,
		BOMStepOneComponent,
		BOMStepThreeComponent,
		BOMStepTwoComponent,
		BOMStepFourComponent,
		DonHangMuaDialogDetailComponent,
		DuyetDonHangMuaComponent,
		LichSuGiaoHangComponent,
		KeHoachNCCGiaoHangComponent,
		RemindDeliveryPlanComponent,
		BOMImportResultComponent,
		KhoDeNghiXuatKhoImportWarningtComponent,
		DeNghiNhapKhoAddEditComponent,
		LichSuMuaHangDialogComponent,
		LichSuNhanHangDialogComponent,
		KhoDeNghiXuatKhoPageEditComponent,
		KhoDeNghiXuatKhoPageDetailComponent,
		KhoXuatKhoPageDetailComponent,
		NhapKhoPageDetailComponent,
		DeNghiNhapKhoDetailComponent,
		DuyetDeNghiNhapKhoComponent,
		DashboardExpiryCardComponent,
		DashboardExpiryConfigComponent,
		DashboardInventoryNormConfigComponent,
		DashboardInventoryNormsCardComponent,
		PrintTemplateComponent,
		LichSuXuatKhoComponent,
		DeNghiChuyenKhoEditPageComponent,
		PhieuKiemKeDetailComponent,
		KhoCKNBPageDetailComponent,
		KhoChuyenKhoPageDetailComponent,
		LichSuThaoTacKhoDialogComponent,
		BOMDeparmentDropdownComponent,
		LichSuThayDoiForecastComponent,
		DoiTraHangDetailComponent,
    ThuMuaHistoryLogComponent,
    DonHangMuaEditComponent
	]
})
export class ReferenceModule { }
